<template>
    <div class="checkout-page">
      <h1>結帳</h1>
      <!-- (1) 未登入時的提示 -->
      <div v-if="!isLoggedIn" class="not-logged-in">
        <p class="checkout-login-tip">登入後即可完成結帳。<br>推薦用 <b>Google / LINE 一鍵登入</b>，免填表單、最快速（發票 Email 也會自動帶正確）。</p>
        <div class="checkout-social-buttons">
          <button class="social-btn google-btn" type="button" @click="handleGoogleLogin">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 48" aria-hidden="true">
              <path fill="#4285F4" d="M39.2 24.45c0-1.55-.16-3.04-.43-4.45H20v8h10.73c-.45 2.53-1.86 4.68-4 6.11v5.05h6.5c3.78-3.48 5.97-8.62 5.97-14.71z" />
              <path fill="#34A853" d="M20 44c5.4 0 9.92-1.79 13.24-4.84l-6.5-5.05C24.95 35.3 22.67 36 20 36c-5.19 0-9.59-3.51-11.15-8.23h-6.7v5.2C5.43 39.51 12.18 44 20 44z" />
              <path fill="#FABB05" d="M8.85 27.77c-.4-1.19-.62-2.46-.62-3.77s.22-2.58.62-3.77v-5.2h-6.7C.78 17.73 0 20.77 0 24s.78 6.27 2.14 8.97l6.71-5.2z" />
              <path fill="#E94235" d="M20 12c2.93 0 5.55 1.01 7.62 2.98l5.76-5.76C29.92 5.98 25.39 4 20 4 12.18 4 5.43 8.49 2.14 15.03l6.7 5.2C10.41 15.51 14.81 12 20 12z" />
            </svg>
            用 Google 登入
          </button>
          <button class="social-btn line-btn" type="button" @click="handleLineLogin">
            <svg viewBox="0 0 25 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M14.7228 9.225V13.0339C14.7228 13.1304 14.6478 13.2054 14.5514 13.2054H13.9406C13.8817 13.2054 13.8281 13.1732 13.8014 13.1357L12.0549 10.7786V13.0393C12.0549 13.1357 11.9799 13.2107 11.8835 13.2107H11.2728C11.1764 13.2107 11.1014 13.1357 11.1014 13.0393V9.23036C11.1014 9.13393 11.1764 9.05893 11.2728 9.05893H11.8781C11.9317 9.05893 11.9906 9.08572 12.0174 9.13393L13.7639 11.4911V9.23036C13.7639 9.13393 13.8389 9.05893 13.9353 9.05893H14.546C14.6424 9.05357 14.7228 9.13393 14.7228 9.225ZM10.3299 9.05357H9.71921C9.62278 9.05357 9.54778 9.12857 9.54778 9.225V13.0339C9.54778 13.1304 9.62278 13.2054 9.71921 13.2054H10.3299C10.4264 13.2054 10.5014 13.1304 10.5014 13.0339V9.225C10.5014 9.13393 10.4264 9.05357 10.3299 9.05357ZM8.85671 12.2464H7.19064V9.225C7.19064 9.12857 7.11564 9.05357 7.01922 9.05357H6.4085C6.31207 9.05357 6.23707 9.12857 6.23707 9.225V13.0339C6.23707 13.0821 6.25314 13.1196 6.28529 13.1518C6.31743 13.1786 6.35493 13.2 6.40314 13.2H8.85136C8.94778 13.2 9.02278 13.125 9.02278 13.0286V12.4179C9.02278 12.3268 8.94779 12.2464 8.85671 12.2464ZM17.9371 9.05357H15.4888C15.3978 9.05357 15.3174 9.12857 15.3174 9.225V13.0339C15.3174 13.125 15.3924 13.2054 15.4888 13.2054H17.9371C18.0335 13.2054 18.1085 13.1304 18.1085 13.0339V12.4232C18.1085 12.3268 18.0335 12.2518 17.9371 12.2518H16.271V11.6089H17.9371C18.0335 11.6089 18.1085 11.5339 18.1085 11.4375V10.8214C18.1085 10.725 18.0335 10.65 17.9371 10.65H16.271V10.0071H17.9371C18.0335 10.0071 18.1085 9.93215 18.1085 9.83572V9.225C18.1031 9.13393 18.0281 9.05357 17.9371 9.05357ZM24.146 4.37679V19.6607C24.1406 22.0607 22.1746 24.0053 19.7692 24H4.48529C2.08529 23.9946 0.14065 22.0232 0.146007 19.6232V4.33929C0.151364 1.93929 2.12279 -0.0053461 4.52279 1.10419e-05H19.8067C22.2067 0.00536818 24.1513 1.97144 24.146 4.37679ZM20.846 10.9446C20.846 7.03393 16.9246 3.85179 12.1085 3.85179C7.29243 3.85179 3.371 7.03393 3.371 10.9446C3.371 14.4482 6.47814 17.3839 10.6781 17.9411C11.7014 18.1607 11.5835 18.5357 11.3531 19.9125C11.3156 20.1321 11.1764 20.775 12.1085 20.3839C13.0406 19.9928 17.1388 17.4214 18.9763 15.3107C20.2406 13.9179 20.846 12.5089 20.846 10.9446Z" fill="currentColor"></path></svg>
            用 LINE 登入
          </button>
        </div>
        <div class="checkout-login-or"><span>或</span></div>
        <button class="btn-login" @click="goLogin">用帳號 / 手機登入</button>
      </div>
  
      <div v-else-if="!cartItems || cartItems.length === 0" class="not-logged-in">
        <p>購物車是空的</p>
        <button class="btn-login" @click="$router.push('/products')">去逛逛</button>
      </div>

      <div v-else-if="isUserProfileIncomplete" class="not-logged-in">
        <p>請先補上會員姓名、電子信箱、手機號碼</p>
        <button class="btn-login" @click="goUpdateUser">前往變更</button>
      </div>
  
      <!-- (2) 已登入 -->
      <div v-else class="checkout-form-wrapper">
        <form @submit.prevent="submitOrder">
          <!-- A. 購買人資訊 -->
          <div class="section user-info-section">
            <h2>購買人資訊</h2>
            <div class="form-group">
              <label for="name">姓名</label>
              <input id="name" type="text" v-model="userProfile.username" disabled />
              <p v-if="formErrors.name" class="field-error">{{ formErrors.name }}</p>
            </div>
            <div class="form-group">
              <label for="phone">手機號碼</label>
              <input id="phone" type="text" inputmode="numeric" v-model="userProfile.phone" disabled />
              <p v-if="formErrors.phone" class="field-error">{{ formErrors.phone }}</p>
            </div>
            <div class="form-group">
              <label for="email">電子郵件</label>
              <input id="email" type="email" v-model="userProfile.email" disabled />
              <p v-if="formErrors.email" class="field-error">{{ formErrors.email }}</p>
            </div>
          </div>
  
          <!-- 收件人資訊 -->
          <div class="section user-info-section">
            <h2>
              收件人資訊
              <label>
                <input type="checkbox" v-model="isSameAsBuyer" @change="onSameAsBuyerChange" />
                同購買人
              </label>
            </h2>
            <div class="form-group">
              <label for="name">姓名</label>
              <input
                id="name"
                type="text"
                v-model="orderData.name"
                placeholder="收件人姓名"
                :class="{ 'is-invalid': formErrors.name }"
              />
              <p v-if="formErrors.name" class="field-error">{{ formErrors.name }}</p>
            </div>
            <div class="form-group">
              <label for="phone">手機</label>
              <input
                id="phone"
                type="text"
                inputmode="numeric"
                v-model="orderData.phone"
                placeholder="收件人手機"
                :class="{ 'is-invalid': formErrors.phone }"
              />
              <p v-if="formErrors.phone" class="field-error">{{ formErrors.phone }}</p>
            </div>
          </div>
  
          <!-- 運送方式 -->
          <div class="section shipping-section">
            <h2>運送方式</h2>
            <div v-for="method in shippingMethods" :key="method.id" class="radio-option">
              <label>
                <input
                  type="radio"
                  name="shipping"
                  :value="method.id"
                  v-model.number="orderData.shipping"
                  @change="onShippingChange(method.id)"
                />
                <img v-if="method.icon_url" :src="method.icon_url" alt="icon" class="shipping-icon" />
                {{ method.name }}
                <span class="method-fee-text">
                (運費 <b style="color:blue">{{ method.shipping_cost }}</b> 元；滿
                <b style="color:blue;">{{ method.free_shipping_threshold }}</b> 免運)
                </span>
              </label>
            </div>
  
            <!-- 宅配地址 -->
            <div v-if="orderData.shipping === 4" class="home-address-block" style="margin-top: 1rem;">
              <div v-if="homeAddressList.length > 0">
                <div class="form-group" style="margin-top: 1rem;">
                <label>希望配達時段</label>
                  <select v-model="orderData.deliveryTimeSlot" class="fancy-select">
                    <option value="01">13時前</option>
                    <option value="02">14-18時</option>
                    <option value="04">不指定</option>
                  </select>
              </div>
                <p>選擇已儲存地址：</p>
                <!-- (A) 現有地址 -->
                <div v-for="(addr, idx) in homeAddressList" :key="idx" class="radio-option">
                  <label>
                    <input
                      type="radio"
                      :value="idx"
                      v-model="orderData.selectedHomeAddrIndex"
                      @change="onSelectHomeAddr"
                    />
                    ({{ addr.zip }}) {{ addr.city }}{{ addr.district }}{{ addr.street }}
                  </label>
                  <!-- 移除地址 -->
                  <button type="button" class="btn-remove-address" @click="removeHomeAddr(idx)">
                      <!-- 桌面版的文字 -->
                      <span class="remove-text-desktop">移除</span>
                      <!-- 手機版的文字/符號 -->
                      <span class="remove-text-mobile">X</span>
                  </button>
                </div>
                <!-- (B) 手動輸入 -->
                <div class="radio-option">
                  <label>
                    <input
                      type="radio"
                      value="-1"
                      v-model="orderData.selectedHomeAddrIndex"
                      @change="onSelectHomeAddr"
                    />
                    手動輸入
                  </label>
                </div>
              </div>
              <div v-else>
                <p>暫無已儲存住家地址，請手動填寫：</p>
              </div>
  
              <!-- 手動填寫地址欄位 -->
              <div class="row-wrap" style="margin-top: 1rem;" v-if="orderData.selectedHomeAddrIndex === '-1'">
                <select
                  class="city-select fancy-select"
                  v-model="orderData.city"
                  @change="onCityChange"
                  :class="{ 'is-invalid': formErrors.address }"
                >
                  <option value="">選擇縣市</option>
                  <option
                    v-for="cityItem in twDistricts"
                    :key="cityItem.CityName"
                    :value="cityItem.CityName"
                  >
                    {{ cityItem.CityName }}
                  </option>
                </select>
                <select
                  class="district-select fancy-select"
                  v-model="orderData.district"
                  :class="{ 'is-invalid': formErrors.address }"
                  @change="onDistrictChange"
                >
                  <option value="">選擇地區</option>
                  <option
                    v-for="area in getDistricts(orderData.city)"
                    :key="area.AreaName"
                    :value="area.AreaName"
                  >
                    {{ area.AreaName }}
                  </option>
                </select>
                <select
                  class="zip-select fancy-select"
                  v-model="orderData.zip"
                  :class="{ 'is-invalid': formErrors.address }"
                  disabled
                >
                  <option :value="orderData.zip">{{ orderData.zip ? orderData.zip : '區號' }}</option>
                </select>
              </div>
              <input
                v-if="orderData.selectedHomeAddrIndex === '-1'"
                class="street-input"
                type="text"
                v-model="orderData.street"
                placeholder="住家地址：巷弄門牌"
                style="margin-top: 8px;"
                :class="{ 'is-invalid': formErrors.address }"
              />
              <p v-if="formErrors.address" class="field-error">{{ formErrors.address }}</p>
            </div>
  
            <!-- 7-11 店到店 -->
            <div v-if="orderData.shipping === 1" style="margin-top: 1rem;"  class="radio-group" :class="{ 'is-invalid': formErrors.CvsAddr }">
              <p>您已選擇 7-11 取貨...</p>
              <div v-if="cvsAddressList.length > 0" >
                <p>選擇已儲存的 7-11 門市：</p>
                <div v-for="(cvsAddr, idx) in cvsAddressList" :key="idx" class="radio-option">
                  <label>
                    <input
                      type="radio"
                      :value="idx"
                      v-model="orderData.selectedCvsAddrIndex"
                      @change="onSelectCvsAddr"
                    />
                    ({{ cvsAddr.store_id }}) {{ cvsAddr.store_name }} - {{ cvsAddr.store_addr }}
                  </label>
                  <!-- 移除 7-11 門市 -->
                  <button type="button" class="btn-remove-cvs" @click="removeCvsAddr(idx)">
                    <span class="remove-text-desktop">移除</span>
                    <span class="remove-text-mobile">X</span>
                  </button>
                </div>
                <div class="radio-option">
                  <label>
                    <input
                      type="radio"
                      value="-1"
                      v-model="orderData.selectedCvsAddrIndex"
                      @change="onSelectCvsAddr"
                    />
                    選擇新的門市
                  </label>
                </div>
              </div>
              <div v-else>
                <p>暫無已儲存 7-11 門市，請選擇新的門市</p>
                <input type="hidden" v-model="orderData.selectedCvsAddrIndex" value="-1" />
              </div>
              <!-- (B) 新門市 btn -->
              <button type="button" class="btn-choose-store" v-if="orderData.selectedCvsAddrIndex === '-1'" @click="openSevenMap">
                選擇門市
              </button>
            </div>
            <p v-if="formErrors.CvsAddr" class="field-error">{{ formErrors.CvsAddr }}</p>
          </div>
  
          <!-- C. 付款方式 -->
          <div class="section payment-section">
            <h2>付款方式</h2>
            <div class="radio-group" :class="{ 'is-invalid': formErrors.payment }">
              <div class="radio-option" v-for="method in paymentMethods" :key="method.method_code">
                <label>
                  <input
                    type="radio"
                    name="payment"
                    :value="method.method_code"
                    v-model="orderData.payment"
                  />
                  {{ method.method_label }}
                </label>
              </div>
              <p v-if="formErrors.payment" class="field-error">{{ formErrors.payment }}</p>
            </div>
  
            <!-- ATM下拉選單 (銀行代碼) -->
            <div v-if="orderData.payment === 'atm'" class="atm-fields">
              <h3>ATM 轉帳資訊</h3>
              <div class="form-group">
                <label>選擇銀行</label>
                <select v-model="orderData.bankCode" class="fancy-select bank-select">
                  <option value="004">004 台灣銀行</option>
                  <option value="822">822 中信銀行</option>
                  <option value="013">013 國泰世華</option>
                </select>
              </div>
            </div>
  
            <!-- 信用卡欄位 (含動態卡組織 Icon) -->
            <div v-else-if="orderData.payment === 'credit'" class="credit-fields card-style-box">
              <h3>信用卡資訊</h3>
              <div class="form-group cc-number-group">
                <label>卡號</label>
                <div class="cc-input-wrapper">
                  <span class="fa-icon cc-fa-icon">
                    <font-awesome-icon :icon="currentCardIcon" />
                  </span>
                  <input
                    type="text"
                    class="cc-number-input"
                    v-model="orderData.cardNumber"
                    placeholder="**** **** **** ****"
                    inputmode="numeric"
                    :class="{ 'is-invalid': formErrors.cardNumber }"
                    @input="onCardNumberChange"
                    maxlength="19"
                  />
                </div>
                <p v-if="formErrors.cardNumber" class="field-error">{{ formErrors.cardNumber }}</p>
              </div>
  
              <div class="card-expiry-row">
                <div class="expiry-wrapper form-group">
                  <label>有效期限 (MMYY)</label>
                  <input
                    type="text"
                    v-model="orderData.cardExpiry"
                    class="cc-expiry-input"
                    placeholder="MMYY"
                    inputmode="numeric"
                    :class="{ 'is-invalid': formErrors.cardExpiry }"
                  />
                  <p v-if="formErrors.cardExpiry" class="field-error">{{ formErrors.cardExpiry }}</p>
                </div>
                <div class="cvc-wrapper form-group">
                  <label>卡片背面安全碼 (CVC)</label>
                  <input
                    type="password"
                    v-model="orderData.cardCvc"
                    class="cc-cvc-input"
                    placeholder="3~4 碼"
                    maxlength="4"
                    inputmode="numeric"
                    :class="{ 'is-invalid': formErrors.cardCvc }"
                  />
                  <p v-if="formErrors.cardCvc" class="field-error">{{ formErrors.cardCvc }}</p>
                </div>
              </div>
            </div>
          </div>
  
          <!-- D. 發票 -->
          <div class="section invoice-section" style="margin-top: 1rem;">
            <h2>發票</h2>
            <!-- 當付款方式為 LINEPAY 時只顯示提示訊息 -->
            <div v-if="orderData.payment === 'linepay'">
              <p>提醒您：因LINEPAY付款流程特殊，發票資訊將於後續通知中補登，請稍候。</p>
            </div>
            <!-- 其他付款方式則顯示原本的發票表單 -->
            <div v-else>
              <div class="form-group">
                <label>發票類型</label>
                <select v-model="orderData.invoiceType" class="fancy-select">
                  <option value="personal">個人(二聯式)</option>
                  <option value="Company">公司(三聯式)</option>
                  <option value="Donate">捐贈</option>
                </select>
              </div>
              <div v-if="orderData.invoiceType === 'personal'" class="radio-group" :class="{ 'is-invalid': formErrors.invoiceNull }">
                <p>選擇載具：</p>
                <div class="radio-option">
                  <label>
                    <input type="radio" name="carrier" value="amego" v-model="orderData.carrierType" />
                    會員載具
                  </label>
                </div>
                <div class="radio-option">
                  <label>
                    <input type="radio" name="carrier" value="3J0002" v-model="orderData.carrierType" />
                    手機條碼
                  </label>
                </div>
                <div class="radio-option">
                  <label>
                    <input type="radio" name="carrier" value="CQ0001" v-model="orderData.carrierType" />
                    自然人憑證
                  </label>
                </div>
                <div v-if="orderData.carrierType === 'amego'" class="form-group" style="margin-top: 1rem;">
                  <label>會員載具 (email)</label>
                  <input type="email" v-model="userProfile.email" disabled readonly />
                  <small>本載具綁定會員Email，不可修改</small>
                </div>
                <div v-if="orderData.carrierType === '3J0002'" class="form-group" style="margin-top: 1rem;">
                  <label>手機條碼</label>
                  <input
                    type="text"
                    v-model="orderData.mobileBarcode"
                    placeholder="/XXXXXXXX"
                    @blur="checkMobileBarcode"
                    :class="{ 'is-invalid': formErrors.invoice }"
                  />
                  <small>請確保以「/」開頭 + 7 碼英數字</small>
                </div>
                <div v-if="orderData.carrierType === 'CQ0001'" class="form-group" style="margin-top: 1rem;">
                  <label>自然人憑證條碼</label>
                  <input
                    type="text"
                    v-model="orderData.citizenBarcode"
                    placeholder="例如 AB12345678901234"
                    @blur="checkCitizenBarcode"
                    :class="{ 'is-invalid': formErrors.invoice }"
                  />
                  <small>範例格式：2碼英文 + 14碼數字，共16碼</small>
                </div>
              </div>
              <div v-else-if="orderData.invoiceType === 'Company'" style="margin-top: 1rem;">
                <div class="form-group">
                  <label>公司抬頭</label>
                  <input
                    type="text"
                    v-model="orderData.companyName"
                    placeholder="請輸入公司抬頭(含有限公司)"
                    :class="{ 'is-invalid': formErrors.invoiceCName }"
                  />
                </div>
                <div class="form-group">
                  <label>統一編號</label>
                  <input
                    type="text"
                    v-model="orderData.taxId"
                    placeholder="請輸入統一編號 (8 碼)"
                    inputmode="numeric"
                    :class="{ 'is-invalid': formErrors.invoiceTID }"
                  />
                </div>
              </div>
              <div v-else-if="orderData.invoiceType === 'Donate'" style="margin-top: 1rem;">
                <p>您的發票將捐贈給公益團體，感謝您的愛心！</p>
              </div>
              <p v-if="formErrors.invoiceCName" class="field-error">{{ formErrors.invoiceCName }}</p>
              <p v-if="formErrors.invoiceTID" class="field-error">{{ formErrors.invoiceTID }}</p>
              <p v-if="formErrors.invoiceNull" class="field-error">{{ formErrors.invoiceNull }}</p>
              <p v-if="formErrors.invoice" class="field-error">{{ formErrors.invoice }}</p>
            </div>
          </div>

  
          <!-- 訂單摘要 -->
          <div class="section order-summary">
            <h2 class="summary-title">訂單摘要</h2>
            <!-- 購買商品明細 -->
            <div class="summary-items">
              <div v-for="(item, idx) in cartItems" :key="item.product_id + '-' + (item.variant_id || 0) + '-' + idx" class="summary-item">
                <img v-if="item.image_url" :src="item.image_url" :alt="item.title" class="summary-item__img" />
                <div class="summary-item__info">
                  <div class="summary-item__title">{{ item.title }}</div>
                  <div class="summary-item__meta">
                    <span v-if="item.variant_name">{{ item.variant_name }}</span>
                    <span> × {{ item.quantity }}</span>
                  </div>
                </div>
                <div class="summary-item__price">NT${{ formatPrice(item.discount_price * item.quantity) }}</div>
              </div>
            </div>
            <p>商品小計：NT${{ formatPrice(cartSubtotal) }}</p>
            <p>
              運費：
              <span v-if="getShippingFee() === 0" class="free-shipping">NT$0 (免運)</span>
              <span v-else>NT${{ getShippingFee() }}</span>
            </p>
            <p v-if="shipShortfall > 0" style="color:#e67e22;font-size:0.9rem;">
              🚚 再消費 NT${{ formatPrice(shipShortfall) }} 即可免運
            </p>
            <p v-if="giftsLoading" style="color:#999;font-size:0.9rem;">🎁 滿額贈載入中…</p>
            <p v-for="g in earnedGifts" :key="g.id" style="color:#27ae60;font-size:0.9rem;">
              🎁 贈品：{{ g.gift_name }} × {{ g.gift_quantity }}
            </p>
            <p v-if="!giftsLoading && nextGift" style="color:#e67e22;font-size:0.9rem;">
              🎁 再消費 NT${{ nextGift.shortfall.toLocaleString() }} {{ nextGift.more ? '即再加贈' : '即贈' }} {{ nextGift.gift.gift_name }}<template v-if="Number(nextGift.gift.gift_quantity) > 1"> × {{ nextGift.gift.gift_quantity }}</template>
            </p>
            <p v-if="!activeCoupon && nextCoupon" style="color:#e67e22;font-size:0.9rem;">
              🏷️ 再消費 NT${{ formatPrice(Number(nextCoupon.min_amount) - cartSubtotal) }} 即可享 {{ Number(nextCoupon.discount_rate) }} 折
            </p>
            <p v-if="activeCoupon" class="coupon-discount-row">
              <span style="color:#27ae60;">🏷️ 已享 {{ Number(activeCoupon.discount_rate) }} 折（滿 NT${{ Number(activeCoupon.min_amount).toLocaleString() }}）</span>
              <span style="color:#c0392b;font-weight:700;">－ NT${{ formatPrice(couponDiscount) }}</span>
            </p>
            <p class="order-total">總計：NT${{ formatPrice(orderTotal) }}</p>
          </div>
  
          <!-- 錯誤訊息 / 送出 -->
          <!-- 購買前告知：個人衛生用品拆封後可能不適用 7 日解除權 -->
          <p class="hygiene-notice">面膜、安瓶、潔顏慕斯屬個人衛生用品，拆除衛生密封包裝後，依法可能不適用 7 日鑑賞期退貨。詳見<router-link to="/productreturns" target="_blank">〈商品退換貨〉</router-link></p>
          <div v-if="stockMsg" class="error-message">⚠️ {{ stockMsg }}</div>
          <div v-if="errorMsg" class="error-message">{{ errorMsg }}</div>
          <button type="submit" class="submit-btn" :disabled="isSubmitting || !!stockMsg">
            {{ isSubmitting ? "送出中..." : "送出訂單" }}
          </button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { loadGifts, loadCoupons, computeEarnedGifts, computeNextGift } from "@/utils/promoData";
  import { checkStockRemote } from "@/utils/stock";
  import Swal from "sweetalert2";
  import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
  import { useSysTempStore } from "@/store/sysTempStore.js";
  import { twDistricts } from "./twalladdress.js";
  import { pixelInitiateCheckout } from "@/plugins/metaPixel";
  // import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'; // 如需要圖示
  
  export default {
    name: "CheckoutPage",
    data() {
      return {
        twDistricts,
        shippingMethods: [],
        paymentMethods: [],
        // 主表單資料
        orderData: {
          buy_name: "",
          buy_phone: "",
          buy_email: "",
          user_id: 0,
          name: "",
          phone: "",
          city: "",
          district: "",
          zip: "",
          street: "",
          store_id : "",
          store_name : "",
          store_addr : "",

          shipping: 4, // 預設宅配
          deliveryTimeSlot: '04', 
          payment: "", // credit/atm...
          bankCode: "013",
          cardNumber: "",
          cardExpiry: "",
          cardCvc: "",
          cardHolderName: "",
          rememberCard: false,
  
          // 發票
          invoiceType: "personal",
          carrierType: "",
          mobileBarcode: "",
          citizenBarcode: "",
          companyName: "",
          taxId: "",
          selectedHomeAddrIndex: "-1",  // 宅配地址的選擇
          selectedCvsAddrIndex: "-1",   // 7-11 門市的選擇
        },
        formErrors: {
          name: "",
          phone: "",
          address: "",
          payment: "",
          invoice: "",
          invoiceNull: "",
          invoiceCName: "",
          invoiceTID: "",
          cardNumber: "",
          cardExpiry: "",
          cardCvc: "",
        },

  
        errorMsg: "",
        isSubmitting: false,
        isSameAsBuyer: true,
        appliedCoupon: null,
        allCoupons: null,      // null = 折扣券還沒載入（先用購物車頁選的）
        couponsPromise: null,
        allGifts: [], // 滿額贈設定（結帳頁打開時抓最新）
        giftsLoading: true,
        giftsPromise: null,
        stockMsg: "",       // 伺服器回報的庫存不足訊息（進結帳頁就檢查）
        stockTimer: null,
      };
    },
    watch: {
      // 結帳頁改數量/刪除商品 → 重新確認庫存
      cartItems: {
        deep: true,
        handler() {
          clearTimeout(this.stockTimer);
          this.stockTimer = setTimeout(() => this.refreshStock(), 400);
        }
      }
    },
    computed: {
      ...mapState(["cartItems", "isLoggedIn", "userProfile"]),
      ...mapGetters(["cartCount"]),
  
      // 贈品：照「目前購物車金額 + 最新活動設定」計算；結帳頁顯示什麼，訂單就記什麼
      // 累贈（is_cumulative）＝每滿一次門檻送一份
      earnedGifts() {
        return computeEarnedGifts(this.allGifts, this.cartSubtotal);
      },
      // 下一個可拿到的滿額贈（提示「再消費 NT$X 即贈／即再加贈…」）
      nextGift() {
        return computeNextGift(this.allGifts, this.cartSubtotal);
      },
      cartSubtotal() {
        return this.cartItems.reduce((sum, item) => sum + item.discount_price * item.quantity, 0);
      },
      // 只有達到折扣券門檻才套用（避免購物車減少後仍顯示/送出不符資格的折扣券）
      // 結帳頁自己決定折扣券：不管從購物車頁、右上角購物車或其他路徑進來都會套用
      // 載入後：優先用購物車頁選的那張（仍有效且達門檻），否則自動套用達門檻中最優惠的
      activeCoupon() {
        if (this.allCoupons === null) {
          if (!this.appliedCoupon) return null;
          return this.cartSubtotal >= Number(this.appliedCoupon.min_amount) ? this.appliedCoupon : null;
        }
        const eligible = this.allCoupons
          .filter(cp => this.cartSubtotal >= Number(cp.min_amount))
          .sort((a, b) => Number(a.discount_rate) - Number(b.discount_rate));
        if (!eligible.length) return null;
        const saved = this.appliedCoupon && eligible.find(cp => cp.id === this.appliedCoupon.id);
        return saved || eligible[0];
      },
      couponDiscount() {
        if (!this.activeCoupon) return 0;
        const discounted = Math.round(this.cartSubtotal * Number(this.activeCoupon.discount_rate) / 10);
        return this.cartSubtotal - discounted;
      },
      // 還沒達門檻的折扣券中門檻最低的那張（顯示「再消費多少即可享幾折」）
      nextCoupon() {
        if (!this.allCoupons) return null;
        const notYet = this.allCoupons.filter(cp => this.cartSubtotal < Number(cp.min_amount));
        if (!notYet.length) return null;
        return notYet.reduce((a, b) => Number(a.min_amount) <= Number(b.min_amount) ? a : b);
      },
      // 目前選的物流還差多少免運（0 = 已免運或沒有免運門檻）
      shipShortfall() {
        const found = this.shippingMethods.find((m) => m.id === Number(this.orderData.shipping));
        if (!found || !(Number(found.free_shipping_threshold) > 0)) return 0;
        return Math.max(0, Number(found.free_shipping_threshold) - this.cartSubtotal);
      },
      shippingFee() {
        const found = this.shippingMethods.find((m) => m.id === Number(this.orderData.shipping));
        if (!found) return 0;
        if (this.cartSubtotal >= found.free_shipping_threshold) return 0;
        return Number(found.shipping_cost);
      },
      orderTotal() {
        return Math.max(0, this.cartSubtotal + this.shippingFee - this.couponDiscount);
      },
      // 篩出 shipping_type==='home'
      homeAddressList() {
        if (!this.userProfile || !Array.isArray(this.userProfile.addresses)) return [];
        return this.userProfile.addresses.filter((a) => a.shipping_type === "home");
      },
      // 篩出 shipping_type==='seven'
      cvsAddressList() {
        if (!this.userProfile || !this.userProfile.addresses) return [];
        return this.userProfile.addresses.filter(a => a.shipping_type === 'seven');
      },
      isUserProfileIncomplete() {
        const up = this.userProfile;
        return up && (!up.username || !up.email || !up.phone);
      },
      // 動態信用卡 icon
      currentCardIcon() {
        const rawNum = this.orderData.cardNumber.replace(/\s+/g, "");
        if (/^4/.test(rawNum)) {
          return ["fab", "cc-visa"];
        } else if (/^5[1-5]/.test(rawNum)) {
          return ["fab", "cc-mastercard"];
        } else if (/^3[47]/.test(rawNum)) {
          return ["fab", "cc-amex"];
        } else if (/^35/.test(rawNum)) {
          return ["fab", "cc-jcb"];
        }
        return ["fas", "credit-card"];
      },
    },
    async created() {
      const useSysTemp = useSysTempStore();
      await useSysTemp.fetchShippingData();
      this.shippingMethods = useSysTemp.shippingMethods;
      await useSysTemp.fetchPaymentData();
      this.paymentMethods = useSysTemp.paymentMethods;
    },
    mounted() {
      // Meta Pixel：開始結帳事件（進入結帳頁且購物車有商品時）
      if (this.cartItems && this.cartItems.length > 0) {
        pixelInitiateCheckout({
          items: this.cartItems,
          value: this.cartSubtotal
        });
      }
      if (this.isLoggedIn && this.userProfile) {
        // 預設持卡人 = 用戶名稱
        this.orderData.cardHolderName = this.userProfile.username || "";

        const formStr = localStorage.getItem("checkoutForm");
        if (formStr) {
          const savedForm = JSON.parse(formStr);
          this.orderData = { ...this.orderData, ...savedForm.orderData };
        }

        // 帶入 config
        const config = this.userProfile.config || null;
        if (config) {
          this.orderData.mobileBarcode = config.default_mobile_barcode || "";
          this.orderData.citizenBarcode = config.default_citizen_barcode || "";
          this.orderData.companyName = config.default_company_name || "";
          this.orderData.taxId = config.default_tax_id || "";

            // 2.2 帶入上次的運送方式 + 住家/門市索引
            if (config.default_shipping) {
            // 例如 1=7-11, 4=宅配
              this.orderData.shipping = config.default_shipping;
            }
            // 若有存下 lastHomeIndex / lastCvsIndex（或如您代碼：selectedHomeAddrIndex / selectedCvsAddrIndex）
            if (config.selectedHomeAddrIndex != null) {
            this.orderData.selectedHomeAddrIndex = String(config.selectedHomeAddrIndex);
            }
            if (config.selectedCvsAddrIndex != null) {
            this.orderData.selectedCvsAddrIndex = String(config.selectedCvsAddrIndex);
            }
        }
      }
      try {
        const savedCoupon = localStorage.getItem('selectedCoupon');
        if (savedCoupon) this.appliedCoupon = JSON.parse(savedCoupon);
      } catch (e) { /* ignore */ }
      this.refreshStock();
      this.couponsPromise = loadCoupons()
        .then(coupons => { this.allCoupons = coupons || []; })
        .catch(() => { /* 抓不到就沿用購物車頁選的 */ });
      // 滿額贈：不再依賴購物車頁存的 localStorage（從登入跳回、重新整理等路徑會遺失），改為當場抓最新設定
      this.giftsLoading = true;
      this.giftsPromise = loadGifts()
        .then(gifts => { this.allGifts = gifts || []; })
        .catch(() => { /* 抓不到就不顯示贈品 */ })
        .finally(() => { this.giftsLoading = false; });

      // 初始化 shipping
      this.onShippingChange(this.orderData.shipping);
      window.addEventListener("message", this.handleCvsStoreMessage);

      this.onSameAsBuyerChange();
    },
    beforeUnmount() {
      window.removeEventListener("message", this.handleCvsStoreMessage);
    },
    methods: {
      async refreshStock() {
        const r = await checkStockRemote(this.cartItems);
        this.stockMsg = r.ok ? "" : r.message;
        return r.ok;
      },
      ...mapMutations(["setRedirectPath", "setUserProfile"]),
      ...mapActions(["clearAllCart"]),
  
      formatPrice(num) {
        if (!num) return 0;
        return num.toLocaleString("en-US");
      },
      goLogin() {
        this.setRedirectPath("/checkout");
        this.$router.push("/login");
      },
      goUpdateUser() {
        this.setRedirectPath("/checkout");
        this.$router.push("/profile");
      },
      // 一鍵登入：登入後自動回到結帳（LoginRes 會讀 redirectPath）
      randomState() {
        const randomBytes = new Uint8Array(20);
        window.crypto.getRandomValues(randomBytes);
        return encodeURIComponent(
          Array.from(randomBytes).map((b) => b.toString(16).padStart(2, "0")).join("")
        );
      },
      handleGoogleLogin() {
        this.setRedirectPath("/checkout");
        const clientId = process.env.VUE_APP_GOOGLE_CODE;
        const redirectUri = encodeURIComponent(process.env.VUE_APP_GOOGLE_REDIRECT_URL);
        const scope = encodeURIComponent("email profile");
        const state = this.randomState();
        axios.post("/api/login/state-save", { state }).then((res) => {
          if (res.data.success) {
            window.location.href =
              "https://accounts.google.com/o/oauth2/v2/auth" +
              `?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&response_type=code`;
          }
        }).catch((error) => console.error(error));
      },
      handleLineLogin() {
        this.setRedirectPath("/checkout");
        const clientId = process.env.VUE_APP_LINE_CLIENT_ID;
        const redirectUri = encodeURIComponent(process.env.VUE_APP_LINE_REDIRECT_URL);
        const scope = encodeURIComponent("openid profile email");
        const state = this.randomState();
        axios.post("/api/login/state-save", { state }).then((res) => {
          if (res.data.success) {
            window.location.href =
              "https://access.line.me/oauth2/v2.1/authorize" +
              `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${scope}&bot_prompt=normal&prompt=consent`;
          }
        }).catch((error) => console.error(error));
      },
      // 依 cityName 取得區域
      getDistricts(cityName) {
        const cityObj = this.twDistricts.find((c) => c.CityName === cityName);
        return cityObj ? cityObj.AreaList : [];
      },
      // 接收 7-11 地圖回傳
      handleCvsStoreMessage(e) {
        console.log("收到 7-11 eMap 訊息 =>", e.data);
        if (e.data.store_id && this.userProfile) {
          // (A) 若已有相同 store_id 則不再新增
          const exist = this.userProfile.addresses.some(addr => {
            return (addr.shipping_type === 'seven' && addr.store_id === e.data.store_id);
          });
          if (exist) {
            console.log("已存在相同門市, 跳過新增...");
            return;
          }
          // (B) 先把舊有 7-11 門市 is_default 全部歸 0
          const updatedAddresses = this.userProfile.addresses.map(addr => {
            if (addr.shipping_type === 'seven') {
              return { ...addr, is_default: 0 };
            }
            return addr;
          });
          // (C) 新增 7-11 address, 設 is_default=1
          const newCvsAddr = {
            user_id: this.userProfile.user_id,
            shipping_type: "seven",
            store_id: e.data.store_id,
            store_name: e.data.store_name,
            store_addr: e.data.store_addr,
            city: "",
            district: "",
            zip: "",
            street: "",
            is_default: 1,
          };
          updatedAddresses.push(newCvsAddr);
          // (D) 更新 userProfile
          this.userProfile.addresses = updatedAddresses;
          this.setUserProfile(this.userProfile);
          // (E) 計算「在 7-11 陣列裏」的索引
          const cvsList = updatedAddresses.filter(a => a.shipping_type === 'seven');
          const newIndex = cvsList.findIndex(item => item.store_id === newCvsAddr.store_id);
          // (F) 設為選擇此新門市
          this.orderData.selectedCvsAddrIndex = String(newIndex);
        }
      },
      onCityChange() {
        this.orderData.district = "";
        this.orderData.zip = "";
      },
      onDistrictChange() {
        const cityObj = this.twDistricts.find((c) => c.CityName === this.orderData.city);
        if (cityObj) {
          const areaObj = cityObj.AreaList.find((a) => a.AreaName === this.orderData.district);
          this.orderData.zip = areaObj ? areaObj.ZipCode : "";
        } else {
          this.orderData.zip = "";
        }
      },
      onShippingChange(shippingId) {
        // 宅配
        if (shippingId === 4) {
          if (this.homeAddressList.length > 0) {
            this.orderData.selectedHomeAddrIndex = "0";
            this.onSelectHomeAddr();
          } else {
            this.orderData.selectedHomeAddrIndex = "-1";
            this.orderData.city = "";
            this.orderData.district = "";
            this.orderData.zip = "";
            this.orderData.street = "";
          }
        }
        // 7-11
        else if (shippingId === 1) {
          if (this.cvsAddressList.length > 0) {
            this.orderData.selectedCvsAddrIndex = "0";
          } else {
            this.orderData.selectedCvsAddrIndex = "-1";
          }
        }
      },
      onSelectHomeAddr() {
        if (this.orderData.selectedHomeAddrIndex === "-1") {
          this.orderData.city = "";
          this.orderData.district = "";
          this.orderData.zip = "";
          this.orderData.street = "";
          return;
        }
        const idx = Number(this.orderData.selectedHomeAddrIndex);
        const addr = this.homeAddressList[idx];
        if (!addr) return;
        this.orderData.city = addr.city || "";
        this.orderData.district = addr.district || "";
        this.orderData.zip = addr.zip || "";
        this.orderData.street = addr.street || "";
      },
      onSelectCvsAddr() {
        if (this.orderData.selectedCvsAddrIndex === "-1") {
          this.orderData.store_id = "";
          this.orderData.store_name = "";
          this.orderData.store_addr = "";
          return;
        }
        const idx = Number(this.orderData.selectedCvsAddrIndex);
        const addr = this.cvsAddressList[idx];
        if (!addr) return;
        this.orderData.store_id = addr.store_id || "";
        this.orderData.store_name = addr.store_name || "";
        this.orderData.store_addr = addr.store_addr || "";
      },
      // 已儲存宅配地址 → 移除
      removeHomeAddr(idx) {
        Swal.fire({
          title: "確定要移除此住家地址嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "確定",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.isConfirmed) {
            const addressId = this.homeAddressList[idx];
            if (!addressId) return;
            // filter out
            const updated = this.userProfile.addresses.filter((addr) => {
              if (addr.shipping_type === "home") {
                // compare city/district/zip/street
                return !(
                  addr.city === addressId.city &&
                  addr.district === addressId.district &&
                  addr.zip === addressId.zip &&
                  addr.street === addressId.street
                );
              }
              return true;
            });
            this.userProfile.addresses = updated;
            this.setUserProfile(this.userProfile);
            // 若移除的 idx == selectedHomeAddrIndex, 重新清空
            this.orderData.selectedHomeAddrIndex = "-1";
            this.orderData.city = "";
            this.orderData.district = "";
            this.orderData.zip = "";
            this.orderData.street = "";
          }
        });
      },
      // 已儲存 7-11 門市 → 移除
      removeCvsAddr(idx) {
        Swal.fire({
          title: "確定要移除此 7-11 門市嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "確定",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.isConfirmed) {
            const address7 = this.cvsAddressList[idx];
            const updated = this.userProfile.addresses.filter((addr) => {
              if (addr.shipping_type === "seven") {
                return !(addr.store_id === address7.store_id);
              }
              return true;
            });
            this.userProfile.addresses = updated;
            this.setUserProfile(this.userProfile);
            // 若移除的 idx == selectedCvsAddrIndex => reset
            this.orderData.selectedCvsAddrIndex = "-1";
          }
        });
      },
  
      onSameAsBuyerChange() {
        if (this.isSameAsBuyer) {
          this.orderData.name = this.userProfile.username || "";
          this.orderData.phone = this.userProfile.phone || "";
        } else {
          this.orderData.name = "";
          this.orderData.phone = "";
        }
      },
      openSevenMap() {
        if (!this.userProfile) {
          this.errorMsg = "請先登入後再進行結帳";
          return;
        }
        const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        axios.post("/api/order/getCvsMapUrl", {
          user_id: this.userProfile.user_id,
          isMobile: isMobile,
        })
        .then((res) => {
          if (res.data.success) {
            const formHtml = res.data.formHtml;
            // 暫存 form
            localStorage.setItem("checkoutForm", JSON.stringify({
              orderData: this.orderData,
            }));
            if (isMobile) {
              document.open();
              document.write(formHtml);
              document.close();
            } else {
              const pop = window.open("", "SevenMap", "width=800,height=600");
              pop.document.write(formHtml);
            }
          } else {
            Swal.fire({
              icon: "error",
              title: res.data.message,
              text: res.data.payuniMsg,
            });
          }
        })
        .catch((err) => {
          console.error(err);
          alert("伺服器錯誤:" + err);
        });
      },
      getShippingFee() {
        const found = this.shippingMethods.find((m) => m.id === Number(this.orderData.shipping));
        if (!found) return 0;
        if (this.cartSubtotal >= found.free_shipping_threshold) {
          return 0;
        }
        return Number(found.shipping_cost);
      },
      onCardNumberChange() {
        let val = this.orderData.cardNumber || "";
        val = val.replace(/\s+/g, "");
        val = val.replace(/(\d{4})(?=\d)/g, "$1 ");
        this.orderData.cardNumber = val;
      },
      checkMobileBarcode() {
        if (!this.orderData.mobileBarcode.match(/^\/[A-Za-z0-9]{7}$/)) {
          this.errorMsg = '手機條碼需以 "/" 開頭 + 7 碼英數字！';
        }
      },
      checkCitizenBarcode() {
        if (!this.orderData.citizenBarcode.match(/^[A-Za-z]{2}\d{14}$/)) {
          this.errorMsg = "自然人憑證條碼需 2碼英文 + 14碼數字，共16碼！";
        }
      },
      isValidTaiwanTaxId(taxId) {
        if (!/^\d{8}$/.test(taxId)) return false;
        const weights = [1, 2, 1, 2, 1, 2, 4, 1];
        let sum = 0;
        for (let i = 0; i < 8; i++) {
          const digit = parseInt(taxId[i], 10);
          let product = digit * weights[i];
          sum += Math.floor(product / 10) + (product % 10);
        }
        return sum % 10 === 0;
      },
  
      async submitOrder() {
        if (!this.cartItems || this.cartItems.length === 0) {
          this.errorMsg = "購物車是空的，請先加入商品";
          return;
        }
        // 贈品還在載入就先等它載完，避免太快送出導致漏記贈品
        if (this.giftsPromise) { try { await this.giftsPromise; } catch (e) { /* ignore */ } }
        // 折扣券也等載完，避免太快送出變成沒折扣
        if (this.couponsPromise) { try { await this.couponsPromise; } catch (e) { /* ignore */ } }
        // 送出前再確認一次最新庫存
        if (!(await this.refreshStock())) return;
        // (A) 驗證欄位
        this.formErrors = {
          name: "",
          phone: "",
          address: "",

          payment: "",
          invoice: "",
          invoiceNull: "",
          invoiceCName: "",
          invoiceTID: "",
          cardNumber: "",
          cardExpiry: "",
          cardCvc: "",
        };
        let hasError = false;
  
        // 收件人
        if (!this.orderData.name) {
          this.formErrors.name = "請填寫姓名！";
          hasError = true;
        } else if (!/^[\u4e00-\u9fa5]+$/.test(this.orderData.name)) {
          this.formErrors.name = "收件人姓名須為中文！";
          hasError = true;
        } else if (this.orderData.name.trim().length < 2) {
          // 物流商要求收件人姓名至少 2 個字，太短會導致訂單成立卻出不了貨
          this.formErrors.name = "收件人姓名太短，請填寫完整姓名（至少 2 個字）！";
          hasError = true;
        }
        if (!this.orderData.phone) {
          this.formErrors.phone = "請填寫手機號碼！";
          hasError = true;
        } else if (!/^09\d{8}$/.test(this.orderData.phone)) {
          this.formErrors.phone = "手機號碼格式錯誤！(需為 09 開頭 10 碼數字)";
          hasError = true;
        }
  
        // 運送=4 => 檢查宅配地址
        if (this.orderData.shipping === 4) {
          if (!this.orderData.city || !this.orderData.district || !this.orderData.zip || !this.orderData.street) {
            this.formErrors.address = "請選擇或填寫完整住家地址！";
            hasError = true;
          }
        } else if (this.orderData.shipping === 1) {
          if (this.orderData.selectedCvsAddrIndex == "-1") {
             this.formErrors.CvsAddr = "請選擇 7-11 門市！";
            hasError = true;
          }
        }

        // 付款
        if (!this.orderData.payment) {
          this.formErrors.payment = "請選擇付款方式！";
          hasError = true;
        } else {
          if (this.orderData.payment === "atm") {
            if (!this.orderData.bankCode) {
              this.errorMsg = "請選擇銀行代碼！";
              hasError = true;
            }
          } else if (this.orderData.payment === "credit") {
            const rawNum = this.orderData.cardNumber.replace(/\s+/g, "");
            if (!rawNum || rawNum.length < 12) {
              this.formErrors.cardNumber = "請輸入正確的信用卡卡號！";
              hasError = true;
            }
            if (!this.orderData.cardExpiry || !this.orderData.cardExpiry.match(/^\d{4}$/)) {
              this.formErrors.cardExpiry = "有效期限格式錯誤 (MMYY)！";
              hasError = true;
            }
            if (!this.orderData.cardCvc || this.orderData.cardCvc.length < 3) {
              this.formErrors.cardCvc = "請輸入3~4碼 CVC！";
              hasError = true;
            }
          }
        }
  

        if(this.orderData.payment !== "linepay"){
          // 發票
          if (this.orderData.invoiceType === "Company") {
            if (!this.orderData.companyName) {
              this.formErrors.invoiceCName = "請填寫公司抬頭！";
              hasError = true;
            }
            if (!this.isValidTaiwanTaxId(this.orderData.taxId)) {
              this.formErrors.invoiceTID = "統一編號格式錯誤，請檢查！";
              hasError = true;
            }
          } else if (this.orderData.invoiceType === "personal") {
            switch (this.orderData.carrierType) {
              case "3J0002":
                if (!this.orderData.mobileBarcode.match(/^\/[A-Za-z0-9]{7}$/)) {
                  this.formErrors.invoice = "手機條碼格式有誤！";
                  hasError = true;
                }
                break;
              case "CQ0001":
                if (!this.orderData.citizenBarcode.match(/^[A-Za-z]{2}\d{14}$/)) {
                  this.formErrors.invoice = "自然人憑證條碼格式有誤！";
                  hasError = true;
                }
                break;
              case "amego":
                // ok
                break;
              case "":
                this.formErrors.invoiceNull = "請選擇載具！";
                hasError = true;
                break;
            }
          }
        }
    
        if (hasError) {
          this.errorMsg = "請檢查資料是否填寫正確！";
          return;
        }
  
        this.errorMsg = "";
        this.isSubmitting = true;
  
        // cartItems
        const send_cartitems = this.cartItems.map((item) => ({
          variant_id: item.variant_id,
          product_id: item.product_id,
          quantity: item.quantity,
        }));
        if (!send_cartitems || send_cartitems.length === 0) {
          this.errorMsg = "購物車內無商品！";
          this.isSubmitting = false;
          return;
        }
  
        /** 
         * 這裡直接在 submitOrder 之前，更新 this.userProfile.addresses，
         * 以便我們送 addresses: this.userProfile.addresses 到後端
         */

        switch (this.orderData.shipping){
            case 1: // 7-11
                if (this.orderData.selectedCvsAddrIndex !== "-1") {
                    // 用舊門市
                    const idx = Number(this.orderData.selectedCvsAddrIndex);
                    const chosenCvs = this.cvsAddressList[idx];
                    if (chosenCvs) {
                        this.userProfile.addresses = this.userProfile.addresses.map(a => {
                        if (a.shipping_type==='seven') {
                            if (a.store_id===chosenCvs.store_id) {
                            return { ...a, is_default: 1 };
                            }
                            return { ...a, is_default: 0 };
                        }
                        return a;
                        });
                        this.orderData.store_id = chosenCvs.store_id;
                        this.orderData.store_name = chosenCvs.store_name;
                        this.orderData.store_addr = chosenCvs.store_addr;
                        this.orderData.city = null;
                        this.orderData.district = null;
                        this.orderData.zip = null;
                        this.orderData.street = null;
                        this.orderData.selectedHomeAddrIndex = "-1";
                    }
                }
                break;
            case 4: // 宅配
                this.orderData.store_id = null;
                this.orderData.store_name = null;
                this.orderData.store_addr = null;
                this.orderData.selectedCvsAddrIndex = "-1";
                if (this.orderData.selectedHomeAddrIndex === "-1") {
                    // 新增或找舊的
                    const existHome = this.userProfile.addresses.find(a =>
                        a.shipping_type==='home' &&
                        a.zip === this.orderData.zip &&
                        a.street=== this.orderData.street
                        );
                        // 若沒存在 => 新增
                        if (!existHome) {
                            // 先把舊 home 全部 is_default=0
                            this.userProfile.addresses = this.userProfile.addresses.map(a => {
                                if (a.shipping_type==='home') {
                                return { ...a, is_default: 0 };
                                }
                                return a;
                            });
                            const newHome = {
                                user_id: this.userProfile.user_id,
                                shipping_type: "home",
                                city: this.orderData.city,
                                district: this.orderData.district,
                                zip: this.orderData.zip,
                                street: this.orderData.street,
                                store_id: null,
                                store_name: null,
                                store_addr: null,
                                is_default: 1
                            };
                            this.userProfile.addresses.push(newHome);
                    } else {
                        // 已存在 => 設 is_default=1 其餘 home=0
                        this.userProfile.addresses = this.userProfile.addresses.map(a => {
                            if (a.shipping_type==='home') {
                            if (a.zip===existHome.zip && a.street===existHome.street) {
                                return { ...a, is_default: 1 };
                            }
                            return { ...a, is_default: 0 };
                            }
                            return a;
                        });
                    }
                    this.orderData.selectedHomeAddrIndex = "0";
                }else{
                    // 用舊的
                    const idx = Number(this.orderData.selectedHomeAddrIndex);
                    const chosen = this.homeAddressList[idx];
                    if (chosen) {
                        this.userProfile.addresses = this.userProfile.addresses.map(a => {
                            if (a.shipping_type==='home') {
                            if (a.zip===chosen.zip && a.street===chosen.street) {
                                return { ...a, is_default: 1 };
                            }
                            return { ...a, is_default: 0 };
                            }
                            return a;
                        });
                        this.orderData.city = chosen.city;
                        this.orderData.district = chosen.district;
                        this.orderData.zip =chosen.zip;
                        this.orderData.street = chosen.street;
                    }
                }
                break;
        }

        // 更新 user config
        const totalAmt = this.orderTotal;
        let config = this.userProfile.config || {};
        config.default_shipping = this.orderData.shipping;
        config.selectedHomeAddrIndex =  this.orderData.selectedHomeAddrIndex;
        config.selectedCvsAddrIndex =  this.orderData.selectedCvsAddrIndex;
        config.default_mobile_barcode = this.orderData.mobileBarcode;
        config.default_citizen_barcode = this.orderData.citizenBarcode;
        config.default_company_name = this.orderData.companyName;
        config.default_tax_id = this.orderData.taxId;
        this.userProfile.config = config;
  
        // 買家資訊
        this.orderData.buy_name = this.userProfile.username;
        this.orderData.buy_phone = this.userProfile.phone;
        this.orderData.buy_email = this.userProfile.email;
        this.orderData.user_id = this.userProfile.user_id;

        //買家運送相關選擇
       //console.log(this.orderData);
       if(this.orderData.payment == "linepay"){
          this.orderData.invoiceType = null;
       }
  
        // 讀取合作夥伴推廣碼（永久保存；實際歸屬由伺服器依「會員綁定 + 夥伴是否 1 年內活躍」判斷）
        let affiliateRefCode = null;
        try {
          const stored = localStorage.getItem('affiliateRef');
          if (stored) {
            const parsed = JSON.parse(stored);
            affiliateRefCode = parsed.code || null;
          }
        } catch (e) { /* ignore */ }

        // 最後把整包 addresses 傳給後端
        const payload = {
          ...this.orderData,
          addresses: this.userProfile.addresses,  // 全部地址
          cartItems: send_cartitems,
          totalAmount: totalAmt,
          coupon_id: this.activeCoupon ? this.activeCoupon.id : null,
          earnedGifts: this.earnedGifts,
          ref_code: affiliateRefCode,
        };

        try {


          const res = await axios.post("/api/order/submitOrder", payload);
          if (res.data.success) {

            console.log(res.data);

            if(this.orderData.payment == "linepay"){
              // 動態建立表單
              const form = document.createElement("form");
              form.setAttribute("action", res.data.result.go_url);
              form.setAttribute("method", "post");
              // 將 body 中的每個 key/value 轉成隱藏欄位
              Object.keys(res.data.result.body).forEach((key) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = res.data.result.body[key];
                form.appendChild(input);
              });
              // 將表單加入 DOM 中（必要，否則無法提交）
              document.body.appendChild(form);
              // 自動提交表單
              form.submit();
              return;
            }

            // 如果有 3D 驗證信用卡網址
            if (res.data.Credit_Url) {
              this.clearAllCart();
              localStorage.removeItem("checkoutForm");
              localStorage.removeItem("selectedCoupon");
              localStorage.removeItem("earnedGifts");
              window.location.href = res.data.Credit_Url;
              return;
            }
            // 更新 userProfile
            this.setUserProfile(this.userProfile);
            // 跳轉至付款頁面
            if (res.data.resData) {
              this.$router.push({
                name: 'PaymentSlip',
                query: { ...res.data.resData }
              });
            }
            this.clearAllCart();
            localStorage.removeItem("checkoutForm");
            localStorage.removeItem("selectedCoupon");
            localStorage.removeItem("earnedGifts");
          } else {
            this.errorMsg = res.data.message || "提交失敗，請稍後再試。";
          }
        } catch (err) {
          console.error(err);
          this.errorMsg = err.response?.data?.message || "伺服器錯誤，請稍後再試。";
        } finally {
          this.isSubmitting = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>

@media (max-width: 768px) {
    .home-address-block .fancy-select {
        font-size: 0.8rem;
    }
}


  .checkout-page {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 30px 20px;
    background: #f9f9f9;
  }
  @media (max-width: 768px) {
    .checkout-page {
      padding: 20px;
      width: auto !important;
    }
  }
  .checkout-page h1 {
    text-align: center;
    font-size: 2rem;
    margin-bottom: 20px;
  }
  .checkout-form-wrapper {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .checkout-form-wrapper form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .section {
    background: #fefefe;
    border: 1px solid #eee;
    border-radius: 6px;
    padding: 16px;
    margin-bottom: 10px;
  }
  .section h2 {
    margin-bottom: 10px;
    font-size: 1.2rem;
    border-left: 4px solid #333;
    padding-left: 8px;
  }
  .form-group {
    margin-bottom: 1rem;
  }
  .form-group label {
    font-weight: bold;
  }
  .form-group input,
  .form-group select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1.2rem;
    width: 100%;
    box-sizing: border-box;
    margin-top: 4px;
  }
  .radio-option {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .btn-remove-address,
  .btn-remove-cvs {
    background-color: #eb3d30;
    border: none;
    border-radius: 4px;
    padding: 4px 8px;
    color: #fff;
    cursor: pointer;
    font-size: 0.9rem;
  }
  .btn-remove-address:hover,
  .btn-remove-cvs:hover {
    background-color: #d10000;
  }
  .shipping-icon {
    width: 32px;
    height: auto;
    margin-right: 6px;
    vertical-align: middle;
  }
  .fancy-select {
    appearance: none;
    background: url("data:image/svg+xml,%3Csvg%20width%3D'10'%20height%3D'5'%20viewBox%3D'0%200%2010%205'%20xmlns%3D'http%3A//www.w3.org/2000/svg'%3E%3Cpath%20fill%3D'%23666'%20d%3D'M0%2C0L10%2C0L5%2C5Z'/%3E%3C/svg%3E")
      no-repeat;
    background-position: calc(100% - 1rem) center;
    background-size: 10px 5px;
    padding-right: 3rem;
    font-size: 1.2rem;
    line-height: normal;
    min-height: 45px;
    border: 1px solid #ccc;
    border-radius: 6px;
    transition: border-color 0.3s, background-color 0.3s;
    cursor: pointer;
  }
  .row-wrap {
    display: flex;
    gap: 10px;
    margin-top: 1rem;
    align-items: center;
  }
  .street-input {
    width: 100%;
    height: 40px;
    padding: 0 1rem;
    font-size: 1.2rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    margin-top: 8px;
    box-sizing: border-box;
  }
  .order-summary .summary-title {
    font-size: 1.3rem;
    margin-bottom: 10px;
  }
  .summary-items {
    border-bottom: 1px solid #eee;
    margin-bottom: 12px;
    padding-bottom: 6px;
  }
  .summary-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
  }
  .summary-item + .summary-item { border-top: 1px dashed #f0f0f0; }
  .summary-item__img {
    width: 56px;
    height: 56px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #eee;
    flex-shrink: 0;
  }
  .summary-item__info { flex: 1; min-width: 0; }
  .summary-item__title { font-size: 0.98rem; color: #333; line-height: 1.4; }
  .summary-item__meta { font-size: 0.88rem; color: #777; margin-top: 2px; }
  .summary-item__price { font-weight: 600; color: #333; white-space: nowrap; }
  .order-total {
    font-size: 1.3rem;
    font-weight: bold;
  }
  .coupon-discount-row {
    color: #c0392b;
    font-size: 0.9rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 4px;
  }
  .error-message {
    color: red;
    margin-top: -10px;
  }
  .submit-btn {
    align-self: flex-end;
    padding: 12px 20px;
    background-color: #ff6600;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  .submit-btn:hover {
    background-color: #ff5500;
  }
  .not-logged-in {
    text-align: center;
    margin: 60px 0;
  }
  .btn-login {
    display: inline-block;
    padding: 10px 20px;
    background-color: #ff6600;
    color: #fff;
    border-radius: 4px;
    text-decoration: none;
    margin-top: 20px;
    border: none;
    cursor: pointer;
  }
  .btn-login:hover {
    background-color: #ff5500;
  }
  .checkout-login-tip {
    color: #555;
    line-height: 1.7;
    font-size: 15px;
  }
  .checkout-social-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 320px;
    margin: 20px auto 0;
  }
  .social-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid #ddd;
    background: #fff;
  }
  .social-btn.google-btn { color: #333; }
  .social-btn.google-btn:hover { background: #f7f7f7; }
  .social-btn.line-btn {
    background: #06c755;
    color: #fff;
    border-color: #06c755;
  }
  .social-btn.line-btn:hover { background: #05b34c; }
  .checkout-login-or {
    max-width: 320px;
    margin: 18px auto 0;
    text-align: center;
    border-top: 1px solid #eee;
    line-height: 0.1;
  }
  .checkout-login-or span {
    background: #fff;
    padding: 0 12px;
    color: #999;
    font-size: 13px;
  }
  .free-shipping {
    color: #028117;
    font-weight: bold;
    margin-left: 4px;
  }
  .is-invalid {
    border-color: red !important;
  }
  .field-error {
    color: red;
    font-size: 0.85rem;
    margin-top: 4px;
  }
  .radio-group.is-invalid {
    border: 1px solid red;
    padding: 10px;
    border-radius: 6px;
  }
  /* ATM */
  .atm-fields {
    border-top: 1px solid #ddd;
    padding-top: 10px;
    margin-top: 10px;
  }
  /* 信用卡 */
  .credit-fields.card-style-box {
    border: 1px solid #ddd;
    padding: 1rem;
    margin-top: 1rem;
    border-radius: 6px;
    background-color: #fafafa;
  }
  .cc-number-group {
    margin-bottom: 1rem;
    position: relative;
  }
  .cc-input-wrapper {
    position: relative;
  }
  .fa-icon.cc-fa-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.5rem;
    color: #666;
    opacity: 0.7;
  }
  .cc-number-input {
    padding-left: 50px !important;
    font-size: 1.1rem;
  }
  .card-expiry-row {
    display: flex;
    gap: 16px;
    margin-bottom: 1rem;
  }
  .cc-expiry-input,
  .cc-cvc-input {
    font-size: 1.1rem;
  }

  .method-fee-text {
  /* 桌面版維持同一行 */
  display: inline;
  margin-left: 6px; /* 視需求可加點左邊距 */
}

/* 手機版: 768px 以下時換行 */
@media (max-width: 768px) {
  .method-fee-text {
    display: block;     /* 讓它成為獨立一行 */
    margin-top: 4px;    /* 與上一行之間的距離 */
    margin-left: 0;     /* 移除左邊距 */
  }
}

/* 預設：桌面版顯示「移除」，隱藏「X」 */
.remove-text-desktop {
  display: inline;
}
.remove-text-mobile {
  display: none;
}

/* 手機版：隱藏「移除」，改顯示「X」 */
@media (max-width: 768px) {
  .remove-text-desktop {
    display: none;
  }
  .remove-text-mobile {
    display: inline;
  }
}

  .hygiene-notice {
  font-size: 0.8rem;
  color: #888;
  line-height: 1.6;
  margin: 10px 0 0;
}
.hygiene-notice a {
  color: #888;
  text-decoration: underline;
}
</style>